<template>
    <v-card elevation="0">
        <v-card-title class="mt-n2">
            <div class="headline">{{$t('app_drawer.event')}}</div>
            <v-spacer></v-spacer>
            <v-btn v-if="loggedInUser && loggedInUser.email != 'api@eventionapp.com' && loggedInUser.email != 'pbc2024@eventionapp.com'" color="primary" @click="$router.push({name: 'event-add'})">
                {{$t('event.create')}}
                <v-icon right>mdi-plus</v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col>
                    <v-select clearable
                              :label="$t('event.companyId')"
                              :placeholder="$t('event.companyId')"
                              :items="companyOptions"
                              v-model="filterByCompanyId">
                    </v-select>
                </v-col>
                <v-col>
                    <v-text-field v-model="search"
                                append-icon="mdi-magnify"
                                :label="$t('search')"
                                single-line
                                hide-details>
                    </v-text-field>
                </v-col>
            </v-row>
            
            <v-data-table :headers="headers"
                        :items="events"
                        :no-data-text="filterByCompanyId ? 'No data available' : 'Please Select Company'"
                        :search="search">
                <template v-slot:item.start_date="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd')}}
                </template>
                <template v-slot:item.end_date="{value}">
                    {{DateTime.fromISO(value).toFormat('yyyy-MM-dd')}}
                </template>
                <template v-slot:item.companyId="{value}">
                    {{(companyMap[value])?companyMap[value].name:""}}
                </template>
                <template v-slot:item.actions="{item}">
                    <!-- <v-btn elevation="0"
                        style="color: #7a9aaa"
                        class="mr-5"
                        @click="$router.push({name: 'event-guests', params: {eventId:item.id}})">
                        {{$t('Guests')}}
                        <v-icon right>mdi-account-supervisor</v-icon>
                    </v-btn> -->
                    <v-btn color="primary"
                        @click="$router.push({name: 'event-details', params: {eventId:item.id}})">
                        {{$t('edit')}}
                        <v-icon right>mdi-account-edit</v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>
    import {computed, ref, watch} from "@vue/composition-api";
    import {useFind} from "feathers-vuex";
    import {DateTime} from "luxon";

    export default {
        name: 'EventList',
        setup(props, {root}) {
            const {Event, Company} = root.$FeathersVuex.api;
            
            const companyParams = computed(() => {
                return {
                    query: {
                        $sort: {
                            name: 1,
                        }
                    }
                }
            });
            const companyData = useFind({model: Company, params: companyParams});
            const companyMap = computed(() => {
                let map = {};

                companyData.items.value.forEach(c => {
                    map[c.id] = c;
                });

                return map;
            });
            
            const companyOptions = computed(() => {
                return companyData.items.value.map(c => {
                    return {text: c.name, value: c.id}
                });
            });
            
            const filterByCompanyId = ref(root.$store.state.prefilledCompanyId);
            watch(filterByCompanyId, (companyId) => {
                root.$store.commit('setPrefilledCompanyId', companyId || '');
            });
            
            const eventParams = computed(() => {
                let params = {
                    query: {
                        $sort: {
                            name: 1,
                        }
                    }
                };

                if (filterByCompanyId && filterByCompanyId.value) {
                    params.query['companyId'] = filterByCompanyId.value;
                } else {
                    // params.query['id'] = 0;
                }
                return params;
            });
            const eventData = useFind({model: Event, params: eventParams});

            const search = ref('');
            const headers_init = [
                {text: root.$t('event.name'), value: 'name'},
                {text: root.$t('mobile_app.company'), value: 'companyId'},
                {text: root.$t('event.start_date'), value: 'start_date'},
                {text: root.$t('event.end_date'), value: 'end_date'},
                {text: '', value: 'actions', filterable: false, width: '280', align: 'end'},
            ];
            
            const headers = computed(() => {
                return headers_init.filter((col) => (col.value !== 'companyId' || !(filterByCompanyId && filterByCompanyId.value)));
            });

            return {
                events: eventData.items,

                search,
                headers,

                DateTime,
                
                companyMap,
                
                companyOptions,
                filterByCompanyId
            }
        },
        computed: {
            loggedInUser() {
                return this.$store.state.auth.user;
            },
        },
    }
</script>
